<template>
  <div class="consent-popup">
    <p class="consent-popup__intro lang_translate">
      We've updated our Terms of Service. Please review and accept to continue using SquashLevels.
    </p>

    <div class="consent-popup__checkboxes">
      <Checkbox
        id="consent-terms"
        v-model="termsAccepted"
        small-print
        label="I have read and accept the Terms of Service and Privacy Policy." />
      <p class="consent-popup__links lang_translate">
        Read our
        <a href="/doc?doc=tsandcs.htm" target="_blank" rel="noopener">Terms of Service</a>
        and
        <a href="/doc?doc=privacy_policy.htm" target="_blank" rel="noopener">Privacy Policy</a>.
      </p>
      <Checkbox
        id="consent-marketing"
        v-model="marketingConsent"
        small-print
        label="Send me relevant news and offers from SquashLevels by email." />
    </div>

    <p v-if="consentStore.errorMessage" class="consent-popup__error">{{ consentStore.errorMessage }}</p>

    <Button
      version="primary"
      label="Continue"
      :disabled="!termsAccepted || consentStore.isSaving"
      @click="submit" />
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import Button from '@/components/ComponentLibrary/Button.vue';
import Checkbox from '@/components/ComponentLibrary/Checkbox.vue';
import { useConsentStore } from '@/store/consentStore';

const emit = defineEmits(['completed']);

const consentStore = useConsentStore();

const termsAccepted = ref(false);
const marketingConsent = ref(false);

const submit = async () => {
  const success = await consentStore.acceptConsent(termsAccepted.value, marketingConsent.value);
  if (success) {
    emit('completed');
  }
};
</script>

<style lang="scss" scoped>
.consent-popup {
  display: flex;
  flex-direction: column;
  gap: 16px;
  text-align: left;

  &__intro {
    margin: 0;
    font-size: 14px;
  }

  &__checkboxes {
    display: flex;
    flex-direction: column;
  }

  &__links {
    margin: -8px 0 0;
    font-size: 12px;

    a {
      color: rgb(var(--v-theme-secondary));
      text-decoration: underline;
    }
  }

  &__error {
    margin: 0;
    color: rgb(var(--v-theme-error));
    font-size: 14px;
  }
}
</style>
